import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { __decorate } from "tslib";
import _ from "lodash";
import jslinq from "jslinq";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ItemsCarousel from "@/components/ItemsCarousel.vue";
import config from "@/config/custom-config";
let Aste = class Aste extends Vue {
  constructor() {
    super(...arguments);
    this.itemsType = "aste";
    this.sizes = [];
    this.activeTemple = {};
    this.metalTemplesNotification = false;
    this.baseAcetatePath = "";
    this.baseStandardPath = "";
    this.materiale = "PL";
    this.animateTemplesColors = false;
    this.animateTemplesSize = false;
    this.animateTemplesMaterial = false;
    this.text = "";
    this.internalChange = false;
    this.materialOptions = [{
      text: 'Plastica',
      id: 'PL'
    }, {
      text: 'Metallo',
      id: 'MT'
    }];
    this.colorMetalOptions = ['GUN', 'GOLD'];
    this.materialDefaultCodes = ['PL', 'MT'];
    this.metalColorDefaultCodes = ['GUN', 'GOLD'];
    this.finituraOptions = [];
    this.defaultFinishingCodes = ["NESSUNO", "N", "M", "S"];
    this.scrolling = false;
    this.showLeftButton = false;
    this.showRightButton = true;
    this.scrollCounter = 0;
  }
  async mounted() {
    await this.getColors();
    await this.getFinishes();
    this.temples;
    this.setupFinishingOptions();
    this.syncTempleFinishFromFront();
  }
  onLocaleChange() {
    this.setupFinishingOptions();
  }
  get config() {
    return config;
  }
  get templesColor() {
    return this.$store.getters["configurator/templesColor"];
  }
  templeSelectionKey(temple) {
    return [String((temple === null || temple === void 0 ? void 0 : temple.U_THE_COLORE) || "").trim().toUpperCase(), String((temple === null || temple === void 0 ? void 0 : temple.U_THE_FINITURA) || "").trim().toUpperCase(), String((temple === null || temple === void 0 ? void 0 : temple.U_THE_LUNGASTA) || "").trim(), String((temple === null || temple === void 0 ? void 0 : temple.U_THE_SOTTOLINEA) || "").trim().toUpperCase()].join("|");
  }
  get activeTempleSelectionKey() {
    return this.templeSelectionKey(this.$store.state.configurator.coloreAste);
  }
  get activeTempleColorCode() {
    var _this$$store$state$co;
    return String(((_this$$store$state$co = this.$store.state.configurator.coloreAste) === null || _this$$store$state$co === void 0 ? void 0 : _this$$store$state$co.U_THE_COLORE) || "").trim().toUpperCase();
  }
  get activeTempleFinishCode() {
    var _this$$store$state$co2;
    return String(((_this$$store$state$co2 = this.$store.state.configurator.coloreAste) === null || _this$$store$state$co2 === void 0 ? void 0 : _this$$store$state$co2.U_THE_FINITURA) || "").trim().toUpperCase();
  }
  set templesColor(value) {
    this.$store.commit("configurator/setTemplesColor", value);
  }
  get templesSize() {
    if (this.$store.state.configurator.lungAste) {
      return this.$store.state.configurator.lungAste;
    } else {
      return "145";
    }
  }
  set templesSize(value) {
    this.$store.commit("configurator/setLungAste", value);
    this.$store.commit("configurator/setTemplesSize", value);
  }
  get templesMaterial() {
    return this.$store.state.configurator.templesMaterial;
  }
  set templesMaterial(value) {
    this.$store.commit("configurator/setTemplesMaterial", value);
  }
  get temples() {
    return this.$store.state.configurator.aste.allColors;
  }
  get frontale() {
    return this.$store.state.configurator.frontale;
  }
  get finiture() {
    return this.$store.state.configurator.aste.allFinishes;
  }
  get allowedTempleFinishCodes() {
    const mode = this.templeFinishMode;
    if (mode === 'automatic') {
      return [];
    }
    const list = this.config.aste_finiture_list;
    if (Array.isArray(list) && list.length > 0) {
      return list.map(f => f.Code);
    }
    const raw = this.config.aste_finiture_codes;
    if (!Array.isArray(raw) || raw.length === 0) {
      return [...this.defaultFinishingCodes];
    }
    return raw;
  }
  get templeFinishMode() {
    return this.config.aste_finiture_mode || 'manual';
  }
  get isTempleFinishFromFront() {
    return this.templeFinishMode === 'frontale';
  }
  get shouldFilterTempleFinishFromFront() {
    return this.config.aste_finiture_frontale_filter_enabled !== false;
  }
  get autoDetectedTempleFinishes() {
    const seen = new Map();
    (this.temples || []).forEach(temple => {
      const code = String((temple === null || temple === void 0 ? void 0 : temple.U_THE_FINITURA) || '').trim().toUpperCase();
      const name = String((temple === null || temple === void 0 ? void 0 : temple.NOME_FINITURA) || code).trim();
      if (code && !seen.has(code)) {
        seen.set(code, name);
      }
    });
    return Array.from(seen.entries()).map(([code, name]) => ({
      code,
      name
    }));
  }
  unsetTemplesMetalColor() {
    this.$store.commit("configurator/unsetTemplesMetalColor");
  }
  get currentSubline() {
    var _this$$store$state$co3;
    return (_this$$store$state$co3 = this.$store.state.configurator.frontale) === null || _this$$store$state$co3 === void 0 ? void 0 : _this$$store$state$co3.U_THE_SOTTOLINEA;
  }
  get allowedMaterialCodes() {
    const raw = this.config.aste_material_codes;
    if (!Array.isArray(raw) || raw.length === 0) {
      return [...this.materialDefaultCodes];
    }
    return raw.filter(code => this.materialDefaultCodes.includes(code));
  }
  get availableMaterialOptions() {
    return this.materialOptions.filter(option => this.allowedMaterialCodes.includes(option.id));
  }
  get allowedMetalColorCodes() {
    const raw = this.config.aste_metalColor_codes;
    if (!Array.isArray(raw) || raw.length === 0) {
      return [...this.metalColorDefaultCodes];
    }
    return raw.filter(code => this.metalColorDefaultCodes.includes(code));
  }
  get availableMetalColorOptions() {
    return this.colorMetalOptions.filter(code => this.allowedMetalColorCodes.includes(code));
  }
  materialLabel(item) {
    return item === 'MT' ? this.$t("message.metallo") : this.$t("message.plastica");
  }
  materialValue(item) {
    return item;
  }
  getMaterialName(materialId) {
    switch (materialId) {
      case 'PL':
        return this.$t("message.Plastica");
      case 'MT':
        return this.$t("message.Metallo");
      default:
        return '';
    }
  }
  getColors() {
    return this.$store.dispatch("configurator/aste/getAllColors");
  }
  getFinishes() {
    return this.$store.dispatch("configurator/aste/getFiniture");
  }
  async setupFinishingOptions() {
    const mode = this.templeFinishMode;
    if (mode === 'frontale') {
      this.finituraOptions = [];
      this.syncTempleFinishFromFront();
      return;
    }
    if (mode === 'automatic') {
      this.finituraOptions = this.autoDetectedTempleFinishes.map(f => ({
        id: f.code,
        text: this.formatAutomaticFinishLabel(f.code)
      }));
    } else {
      const list = this.config.aste_finiture_list;
      if (Array.isArray(list) && list.length > 0) {
        this.finituraOptions = list.map(f => ({
          id: f.Code,
          text: this.formatFinishLabel(f.Name)
        }));
      } else {
        const configuredCodes = this.allowedTempleFinishCodes;
        const finishesByCode = new Map((this.finiture || []).map(f => [f.Code, f.Name]));
        this.finituraOptions = configuredCodes.filter(code => finishesByCode.has(code)).map(code => ({
          id: code,
          text: this.formatFinishLabel(finishesByCode.get(code))
        }));
      }
    }
    this.ensureValidTempleFinishingSelection();
    await this.$nextTick();
    this.syncActiveTempleWithFinishFilter();
  }
  formatFinishLabel(value) {
    const text = String(value || "").trim().toUpperCase();
    if (!text) return text;
    const translationMap = {
      LUCIDO: "message.Lucido",
      NATURALE: "message.Naturale",
      OPACO: "message.Opaco",
      NESSUNO: "message.Lucido"
    };
    const key = translationMap[text];
    if (key) {
      return this.$t(key);
    }
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }
  formatAutomaticFinishLabel(code) {
    const normalizedCode = String(code || "").trim().toUpperCase();
    const labels = {
      M: "message.Opaco",
      NESSUNO: "message.Lucido",
      S: "message.Lucido",
      N: "message.Naturale"
    };
    const translationKey = labels[normalizedCode];
    return translationKey ? this.$t(translationKey) : normalizedCode;
  }
  ensureValidTempleFinishingSelection() {
    const current = this.finituraAsteSelection;
    const allowedIds = this.finituraOptions.map(item => item.id);
    if (allowedIds.length === 0) return;
    if (!allowedIds.includes(current)) {
      this.finituraAsteSelection = allowedIds.includes("NESSUNO") ? "NESSUNO" : allowedIds.includes("S") ? "S" : allowedIds[0];
    }
  }
  syncTempleFinishFromFront() {
    if (this.isTempleFinishFromFront) {
      const finish = this.finitura || "S";
      if (this.finituraAste !== finish) {
        this.finituraAste = finish;
      }
    }
  }
  templeFinishFilterCodes(value) {
    const normalizedValue = String(value || "").trim().toUpperCase();
    // In modalita automatica il codice e vincolante: NESSUNO e S hanno la
    // stessa label "Lucido", ma rappresentano due finiture distinte nei dati.
    if (this.templeFinishMode === 'automatic') return [normalizedValue];
    if (normalizedValue === "NESSUNO") return ["NESSUNO", "S"];
    if (normalizedValue === "S") return ["S", "NESSUNO"];
    return [normalizedValue];
  }
  normalizeTempleColorCode(value) {
    const code = String(value || "").trim().toUpperCase();
    const numericColor = code.match(/^[A-Z]*(\d+)$/);
    if (!numericColor) return code;
    return String(parseInt(numericColor[1], 10));
  }
  syncActiveTempleWithFinishFilter() {
    if (this.templeFinishMode !== 'automatic' && (!this.isTempleFinishFromFront || !this.shouldFilterTempleFinishFromFront) || !this.finituraAsteSelection) {
      return;
    }
    const activeTemple = this.templesColor;
    const availableTemples = this.filteredTemples;
    if (availableTemples.length === 0) return;
    const configuredDefaultColor = this.config.aste_default_color_enabled !== false ? this.config.defaultTemplesColor || "" : "";
    const preferredColor = (activeTemple === null || activeTemple === void 0 ? void 0 : activeTemple.U_THE_COLORE) || configuredDefaultColor;
    const selectedFinishCodes = this.templeFinishFilterCodes(this.finituraAsteSelection);
    const activeFinishCode = String((activeTemple === null || activeTemple === void 0 ? void 0 : activeTemple.U_THE_FINITURA) || "").trim().toUpperCase();
    const activeTempleIsVisible = availableTemples.some(temple => temple.ItemCode === (activeTemple === null || activeTemple === void 0 ? void 0 : activeTemple.ItemCode) && selectedFinishCodes.includes(activeFinishCode) && String(temple.U_THE_FINITURA || "").trim().toUpperCase() === activeFinishCode);
    if (activeTempleIsVisible) return;
    // Mantiene il colore configurato di default, scegliendo però la variante
    // con la finitura attualmente selezionata. Se quella variante non esiste,
    // usa la prima asta realmente disponibile nel filtro.
    const sameExactColor = availableTemples.find(temple => temple.U_THE_COLORE === preferredColor);
    const normalizedPreferredColor = this.normalizeTempleColorCode(preferredColor);
    const sameNormalizedColor = availableTemples.find(temple => normalizedPreferredColor !== "" && this.normalizeTempleColorCode(temple.U_THE_COLORE) === normalizedPreferredColor);
    this.setActiveTemple(sameExactColor || sameNormalizedColor || availableTemples[0]);
  }
  /**
   * Quando cambia il frontale, il filtro delle aste cambia in base alla
   * sottolinea. L'asta selezionata in precedenza però può non appartenere più
   * alla nuova lista: in quel caso il carrello continuerebbe a usare l'asta
   * vecchia. Allinea quindi sempre l'asta attiva con quelle effettivamente
   * filtrate, mantenendo quando possibile il colore di default.
   */
  syncActiveTempleWithFilteredTemples() {
    const availableTemples = this.filteredTemples;
    if (availableTemples.length === 0) return;
    const activeTemple = this.templesColor;
    const activeKey = activeTemple ? this.templeSelectionKey(activeTemple) : "";
    if (activeKey && availableTemples.some(temple => this.templeSelectionKey(temple) === activeKey)) {
      return;
    }
    const configuredDefaultColor = this.config.aste_default_color_enabled !== false ? this.config.defaultTemplesColor || "" : "";
    const normalizedDefaultColor = this.normalizeTempleColorCode(configuredDefaultColor);
    const defaultTemple = availableTemples.find(temple => temple.U_THE_COLORE === configuredDefaultColor) || availableTemples.find(temple => normalizedDefaultColor !== "" && this.normalizeTempleColorCode(temple.U_THE_COLORE) === normalizedDefaultColor);
    this.setActiveTemple(defaultTemple || availableTemples[0]);
  }
  getTempleImageUrl(t) {
    var _this$$settings;
    // recuper colori dalla cartella frontali perchè  nella cartella aste sono ruotate
    // @ts-ignore
    const baseColorsUrl = ((_this$$settings = this.$settings) === null || _this$$settings === void 0 ? void 0 : _this$$settings.VUE_APP_COLORS_URL) || process.env.VUE_APP_COLORS_URL || "";
    return baseColorsUrl + t.U_THE_COLORE + ".jpg";
  }
  setActiveTemple(t) {
    console.log("setActiveTemple", t);
    this.activeTemple = t;
    this.templesMaterial = t.materiale && t.materiale != "" ? t.materiale : "PL";
    this.templesColor = t;
    // Setta il materiale corretto
    if (t.materiale == "MT") {
      // Se metallo, setta GUN o GOLD in base al colore attualmente selezionato
      this.coloreMetalloAste = t.U_THE_COLORE.endsWith("GUN") ? "GUN" : "GOLD";
    } else {
      // Se plastica, togli il metalColor se presente
      this.unsetTemplesMetalColor();
    }
    if (t.U_THE_LUNGASTA != this.templesSize && this.currentSubline != 'IG04TH') {
      this.templesSize = t.U_THE_LUNGASTA;
    }
  }
  isActive(t) {
    return this.activeTemple == t;
  }
  get sizeButtons() {
    return this.sizes.filter(size => {
      // @ts-ignore
      return this.sizesAvailables.indexOf(size) >= 0;
    });
  }
  get filteredTemples() {
    let result = this.temples;
    result = result.filter(t => this.allowedMaterialCodes.includes(t.materiale));
    if (this.allowedMaterialCodes.length > 0 && !this.allowedMaterialCodes.includes(this.materiale)) {
      this.materiale = this.allowedMaterialCodes[0];
    }
    if (this.templesSize) {
      console.log("Filtering temples by size:", this.templesSize);
      result = result.filter(t => {
        return t.U_THE_LUNGASTA == this.templesSize;
      });
    }
    if (this.materiale) {
      result = result.filter(t => {
        return t.materiale == this.materiale;
      });
    }
    // /**
    //  * essendoci colori per ogni versione del materiale
    //  * vado a identificare i colori per le aste in metallo GUN/GOLD
    //  */
    if (this.materiale == "MT" && this.coloreMetalloAste) {
      if (this.allowedMetalColorCodes.length > 0 && !this.allowedMetalColorCodes.includes(this.coloreMetalloAste)) {
        this.coloreMetalloAste = this.allowedMetalColorCodes[0];
      }
      result = result.filter(t => {
        if (t.U_THE_COLORE) {
          if (this.coloreMetalloAste == "GUN") {
            return t.U_THE_COLORE.search("GUN") != -1;
          } else {
            return t.U_THE_COLORE.search("GOLD") != -1;
          }
        }
      });
    }
    //voglio che vengano mostrate solo le aste con la sottolinea uguale alla sottolinea del frontale
    if (this.currentSubline) {
      result = result.filter(t => {
        return t.U_THE_SOTTOLINEA == this.frontale.U_THE_SOTTOLINEA;
      });
    }
    if ((this.templeFinishMode === 'automatic' || this.isTempleFinishFromFront && this.shouldFilterTempleFinishFromFront) && this.finituraAsteSelection) {
      let finishCodes = this.templeFinishFilterCodes(this.finituraAsteSelection);
      let filteredByFinish = result.filter(t => finishCodes.includes(String(t.U_THE_FINITURA || "").trim().toUpperCase()));
      if (filteredByFinish.length === 0 && this.templeFinishMode === 'automatic') {
        var _result$find;
        const fallbackFinish = (_result$find = result.find(t => t.U_THE_FINITURA)) === null || _result$find === void 0 ? void 0 : _result$find.U_THE_FINITURA;
        if (fallbackFinish && fallbackFinish !== this.finituraAsteSelection) {
          this.finituraAsteSelection = fallbackFinish;
          finishCodes = this.templeFinishFilterCodes(this.finituraAsteSelection);
          filteredByFinish = result.filter(t => finishCodes.includes(String(t.U_THE_FINITURA || "").trim().toUpperCase()));
        }
      }
      result = filteredByFinish;
    }
    //voglio che la varibaile filteredtemples nello store sia uguale a result
    this.$store.commit("setFilteredTemples", result);
    console.log("result", result);
    return result;
  }
  get misuraAste() {
    return this.$store.state.configurator.misuraAste;
  }
  get finituraAste() {
    return this.$store.state.configurator.finituraAste;
  }
  set finituraAste(f) {
    this.$store.commit("configurator/setTemplesFinishing", f || "S");
  }
  get finituraAsteSelection() {
    if (this.templeFinishMode === 'automatic') return this.finituraAste;
    return this.finituraAste === "S" ? "NESSUNO" : this.finituraAste;
  }
  set finituraAsteSelection(value) {
    this.finituraAste = this.templeFinishMode === 'automatic' ? value || "S" : !value || value === "NESSUNO" ? "S" : value;
  }
  get tintaUnita() {
    return this.$store.state.tintaUnita;
  }
  set tintaUnita(newVal) {
    this.$store.commit("setTintaUnita", newVal);
  }
  get finitura() {
    return this.$store.state.configurator.finitura;
  }
  get coloreMetalloAste() {
    return this.$store.state.coloreMetalloAste;
  }
  set coloreMetalloAste(c) {
    // TODO: vedere come gestire questa cosa in maniera più generica su configurator-base-app
    // perché PRO...272 e PRO...280 non c'entrano con iGreen
    this.$store.commit("configurator/setTemplesMetalColor", c == "GUN" ? "PRO0000272" : "PRO0000280");
    this.$store.commit("setTemplesMetalColor", c);
  }
  get sizesAvailables() {
    let temples = jslinq(this.temples);
    return temples.where(t => this.materiale == t.materiale && this.allowedMaterialCodes.includes(t.materiale)).orderBy(t => t.U_THE_LUNGASTA).select(t => t.U_THE_LUNGASTA).distinct().toList();
  }
  noTempleAvailable() {
    if (this.filteredTemples.length == 0) {
      return true;
    } else {
      return false;
    }
  }
  onMaterialeChanged(newVal) {
    if (newVal == "MT") {
      this.templesSize = "143";
    }
  }
  onAsteFinitureCodesChanged() {
    this.setupFinishingOptions();
  }
  onFinitureListChanged() {
    this.setupFinishingOptions();
  }
  onColoreMetalloAsteChanged(newVal) {
    /**
      Quando cambio colore del metallo
      sostituisco la porzione di nome necessaria
      per selezionare il colore se presente
    */
    let at = this.templesColor;
    let ma = "";
    if (!_.isEmpty(at)) {
      if (newVal != "GUN") {
        ma = at.U_THE_COLORE.replace("GUN", "GOLD");
      } else {
        ma = at.U_THE_COLORE.replace("GOLD", "GUN");
      }
      let a = this.temples.filter(t => {
        return t.U_THE_LUNGASTA == at.U_THE_LUNGASTA && t.U_THE_COLORE == ma;
      });
      if (a.length > 0) {
        this.setActiveTemple(a[0]);
      } else {
        if (this.filteredTemples.length != 0) {
          this.setActiveTemple(this.filteredTemples[0]);
        }
      }
    }
  }
  onTemplesSizeChanged(newVal) {
    /*
          se ho un'asta attiva e cambia la misura
          sostituisco all'asta attiva una con
          stesso colore, stesso materiale e misura selezionata
        */
    if (this.currentSubline == 'IG04TH') return;
    let at = this.templesColor;
    if (!_.isEmpty(at)) {
      let a = this.temples.filter(t => {
        return t.U_THE_COLORE == at.U_THE_COLORE && t.METALTEMPLE == at.METALTEMPLE && t.U_THE_LUNGASTA == newVal;
      });
      if (a.length > 0) {
        this.setActiveTemple(a[0]);
      } else {
        if (this.filteredTemples.length != 0) {
          this.setActiveTemple(this.filteredTemples[0]);
        }
      }
    }
  }
  onFinituraAsteChanged(newVal) {
    this.syncTempleFinishFromFront();
    this.syncActiveTempleWithFinishFilter();
    if (newVal) {
      if (this.finituraAste != this.finitura) {
        this.tintaUnita = false;
      }
    }
  }
  onFrontFinishingChanged() {
    this.syncTempleFinishFromFront();
  }
  onAsteFinitureModeChanged() {
    this.setupFinishingOptions();
    this.syncTempleFinishFromFront();
  }
  onTemplesColorChanged(newVal, oldVal) {
    if (newVal && (!oldVal || newVal.U_THE_COLORE != oldVal.U_THE_COLORE)) {
      this.activeTemple = newVal;
    }
    this.$nextTick(() => this.syncActiveTempleWithFinishFilter());
  }
  onFrontaleChanged() {
    this.$nextTick(() => {
      this.syncActiveTempleWithFilteredTemples();
      this.syncActiveTempleWithFinishFilter();
    });
  }
  onActiveTempleDataChanged() {
    this.$nextTick(() => this.syncActiveTempleWithFinishFilter());
  }
};
__decorate([Prop({
  default: false
})], Aste.prototype, "darkTheme", void 0);
__decorate([Prop({
  default: false
})], Aste.prototype, "expanded", void 0);
__decorate([Watch('$i18n.locale')], Aste.prototype, "onLocaleChange", null);
__decorate([Watch("materiale")], Aste.prototype, "onMaterialeChanged", null);
__decorate([Watch("config.aste_finiture_codes", {
  deep: true
})], Aste.prototype, "onAsteFinitureCodesChanged", null);
__decorate([Watch("finiture", {
  deep: true
})], Aste.prototype, "onFinitureListChanged", null);
__decorate([Watch("coloreMetalloAste")], Aste.prototype, "onColoreMetalloAsteChanged", null);
__decorate([Watch("templesSize")], Aste.prototype, "onTemplesSizeChanged", null);
__decorate([Watch("finituraAste")], Aste.prototype, "onFinituraAsteChanged", null);
__decorate([Watch("finitura")], Aste.prototype, "onFrontFinishingChanged", null);
__decorate([Watch("config.aste_finiture_mode")], Aste.prototype, "onAsteFinitureModeChanged", null);
__decorate([Watch("templesColor")], Aste.prototype, "onTemplesColorChanged", null);
__decorate([Watch("frontale", {
  deep: true
})], Aste.prototype, "onFrontaleChanged", null);
__decorate([Watch("activeTempleColorCode", {
  immediate: true
}), Watch("activeTempleFinishCode", {
  immediate: true
})], Aste.prototype, "onActiveTempleDataChanged", null);
Aste = __decorate([Component({
  components: {
    ItemsCarousel
  }
})], Aste);
export default Aste;